<div class="ui-tab w-100 h-100 flex-col gap-24 custom-events-wrapper">
  <div class="flex-col gap-8 input-field">
    <div>{{ 'EDIT_CUSTOM_EVENT.NAME'|translate }}</div>
    <div class="flex-row">
      <input class="ui-input w-100"
             [(ngModel)]="selectedCustomEvent.name"
             [placeholder]="'EDIT_CUSTOM_EVENT.PLACEHOLDERS.UNTITLED'|translate"
      >
    </div>
  </div>
  <div class="flex-col gap-8 input-field">
    <div>{{ 'EDIT_CUSTOM_EVENT.VIDEO_LENGTH'|translate }}</div>
    <div class="flex-row p-r">
      <input class="ui-input w-100" type="number"
             [(ngModel)]="selectedCustomEvent.videoLength"
             [min]="10" [max]="60"
      >
      <div class="input-sec-suffix">{{ 'EDIT_CUSTOM_EVENT.SEC'|translate }}</div>
    </div>
  </div>

  <div class="h-100 min-h-0 w-100">
    <div class="h-100 min-h-0 flex-col w-100">
      <div class="flex-row space-between-center mb-10">
        <div>
          {{ 'EDIT_CUSTOM_EVENT.LIMIT'|translate:{selected: selectedCustomEvent?.fields?.length ?? 0} }}
        </div>
        <div>
          <ui-button (click)="addField()" type="noBorderPrimary"
                     [disabled]="selectedCustomEvent?.fields?.length >= 10"
          >
            {{ 'EDIT_CUSTOM_EVENT.BUTTONS.ADD'|translate }}
          </ui-button>
        </div>
      </div>

      <!-- TABLE -->
      @if (tableConfig()) {
        <ui-dataset-table
          [data]="selectedCustomEvent.fields"
          [config]="tableConfig()!"
          (rowAction)="onRowAction($event)"
        ></ui-dataset-table>
      }

      <!-- CELL TEMPLATES -->
      <ng-template #nameCell let-row>
        <input
          class="ui-input narrow-input-40"
          [(ngModel)]="row.name"
          [placeholder]="'EDIT_CUSTOM_EVENT.PLACEHOLDERS.NAME'|translate"
        >
      </ng-template>

      <ng-template #typeCell let-row>
        <mat-select class="ui-selector"
                    style="max-width: 320px;"
                    [placeholder]="'EDIT_CUSTOM_EVENT.PLACEHOLDERS.TYPE'|translate"
                    [(ngModel)]="row.type"
        >
          <mat-option [value]="CustomEventFieldType.Text">
            {{ 'EDIT_CUSTOM_EVENT.TYPES.TEXT'|translate }}
          </mat-option>
          <mat-option [value]="CustomEventFieldType.Boolean">
            {{ 'EDIT_CUSTOM_EVENT.TYPES.BOOLEAN'|translate }}
          </mat-option>
          <mat-option [value]="CustomEventFieldType.Number">
            {{ 'EDIT_CUSTOM_EVENT.TYPES.NUMBER'|translate }}
          </mat-option>
          <mat-option [value]="CustomEventFieldType.Decimal">
            {{ 'EDIT_CUSTOM_EVENT.TYPES.DECIMAL'|translate }}
          </mat-option>
        </mat-select>
      </ng-template>
    </div>
  </div>
</div>
